import { useCallback, useEffect, useState } from "react";
import axios from "axios";

// Ж22 (TZ-7 п.2): показ уведомлений порциями 10/20/30/50 с запоминанием выбора
export const PAGE_SIZES = [10, 20, 30, 50];
export const INBOX_CHANGED_EVENT = "rv-inbox-changed";

export const usePageSize = (storageKey) => {
  const [size, setSize] = useState(() => {
    try {
      const v = Number(localStorage.getItem(storageKey));
      return PAGE_SIZES.includes(v) ? v : 10;
    } catch (e) { return 10; }
  });
  const update = (v) => {
    setSize(v);
    try { localStorage.setItem(storageKey, String(v)); } catch (e) { /* приватный режим */ }
  };
  return [size, update];
};

// Список с серверной порцией (limit/offset), «показать ещё» и удалением поштучно
export const usePagedList = (url, size) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [unread, setUnread] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const apply = (data) => {
    if (typeof data.total === "number") setTotal(data.total);
    if (typeof data.unread === "number") setUnread(data.unread);
  };

  const reload = useCallback(async () => {
    try {
      const r = await axios.get(url, { params: { limit: size, offset: 0 } });
      setItems(r.data.items || []);
      apply(r.data);
      return r.data;
    } catch (e) { return null; } finally { setLoaded(true); }
  }, [url, size]);

  useEffect(() => { reload(); }, [reload]);

  const loadMore = async () => {
    try {
      const r = await axios.get(url, { params: { limit: size, offset: items.length } });
      const seen = new Set(items.map((i) => i.id));
      setItems((prev) => [...prev, ...(r.data.items || []).filter((i) => !seen.has(i.id))]);
      apply(r.data);
    } catch (e) { /* не критично */ }
  };

  const remove = async (id) => {
    const r = await axios.delete(`${url}/${id}`);
    setItems((prev) => prev.filter((i) => i.id !== id));
    apply(r.data);
    return r.data;
  };

  return { items, setItems, total, setTotal, unread, setUnread, loaded, reload, loadMore, remove, apply };
};

export const notifyInboxChanged = () => {
  try { window.dispatchEvent(new Event(INBOX_CHANGED_EVENT)); } catch (e) { /* noop */ }
};
